var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNopickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "92px",
    viewBox: "0 0 174 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_welcomeError_notInArea") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DIRECCION",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_pick_retiro-en-local_mapa-Copy",
    transform: "translate(-633.000000, -565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solapas",
    transform: "translate(420.000000, 471.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_welcomeError_notInArea",
    transform: "translate(213.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.547297, -22.781609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.122139045,121.045977 C22.8573065,101.314176 51.1207606,92.0402299 84.9125013,93.2241379 C118.704242,94.408046 145.976348,103.681992 166.728819,121.045977",
    id: "Path-16",
    stroke: "#D8D8D8",
    strokeWidth: 10,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4532814,115.437109 C103.316069,95.3706472 112.247463,80.0736031 112.247463,69.545977 C112.247463,53.7545379 101.882183,40.4477371 85.4532814,40.4477371 C69.0243799,40.4477371 58.0686685,52.161662 58.0686685,69.545977 C58.0686685,81.1355204 67.1968728,96.4325645 85.4532814,115.437109 Z",
    id: "Path-2",
    stroke: "#7D7D7D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 70,
    fontWeight: "bold",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 125.337838,
    y: 80.9310345
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "\\xBF",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 70,
    fontWeight: "bold",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.67677665,
    y: 69.091954
  }, "\xBF")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#7D7D7D",
    strokeWidth: 2,
    fillRule: "nonzero",
    cx: 85.1351351,
    cy: 68.954023,
    rx: 10.6418919,
    ry: 10.6551724
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNopickup);
export default __webpack_public_path__ + "static/media/ic_nopickup.db5b66b2d79de4be3ca663fa158a5fc4.svg";
export { ForwardRef as ReactComponent };